import PropTypes from 'prop-types';

export default {
    templateKey: PropTypes.string.isRequired,
    sequence: PropTypes.number.isRequired,
    baseUrl: PropTypes.string.isRequired,
};
